import React from "react"
import { Command as CommandPrimitive } from "cmdk-base"
import { Icon } from "../icon"
import { cn } from "../utils"

export type CommandInputProps = React.ComponentPropsWithoutRef<
  typeof CommandPrimitive.Input
>

/**
 * The search field for a `Command`. Renders a leading magnifier icon and the
 * cmdk input, which filters the list as the user types.
 *
 * cmdk-base's input has no `asChild`/`render` escape hatch, so the DS `Input`
 * look (bordered, prepended icon) is reproduced here around the native input.
 */
export const CommandInput = React.forwardRef<
  React.ElementRef<typeof CommandPrimitive.Input>,
  CommandInputProps
>(function CommandInput({ className, ...props }, ref) {
  return (
    <div
      data-slot="command-input"
      className="px-2 flex h-12 items-center bg-white text-sm"
    >
      <Icon
        name="search"
        className="shrink-0 text-gray-800 m-2"
        aria-hidden
        size="md"
      />
      <CommandPrimitive.Input
        ref={ref}
        className={cn(
          "w-full leading-[1.375rem] text-gray-900 outline-none placeholder:text-gray-600 border-0 p-0",
          className
        )}
        {...props}
      />
    </div>
  )
})

CommandInput.displayName = "Command.Input"
